var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExtract = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "extract_svg__a",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 8.5H8.5V14h4.583c.507 0 .917-.41.917-.917zM13 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3.5V7.5H13z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14 8.5H8.5V14h4.583c.507 0 .917-.41.917-.917zM13 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3.5V7.5H13z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.5 8.5h-1v-1h1zm5.5 0v-1h1v1zM8.5 14v1h-1v-1zm-1-1h1v1h-1zm0-5.5h-1v-1h1zm5.5 0h1v1h-1zm-4.5 0H14v2H8.5zm-1 6.5V8.5h2V14zm5.583 1H8.5v-2h4.583zM15 13.083A1.917 1.917 0 0 1 13.083 15v-2a.083.083 0 0 0-.083.083zM15 8.5v4.583h-2V8.5zM12 2a2 2 0 0 1 2 2h-2zM4 2h8v2H4zM2 4a2 2 0 0 1 2-2v2zm0 8V4h2v8zm2 2a2 2 0 0 1-2-2h2zm3.5 0H4v-2h3.5zm1-6.5V13h-2V7.5zm4.5 1H7.5v-2H13zM14 4v3.5h-2V4z",
  mask: "url(#extract_svg__a)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExtract);
export default ForwardRef;